function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00789 4.66237V3.31685H7.32211V4.66237H6.00789ZM2.87878 10.4512C3.94268 11.4943 5.20475 12.0158 6.665 12.0158C8.12525 12.0158 9.37689 11.4943 10.4199 10.4512C11.4838 9.38732 12.0158 8.12525 12.0158 6.665C12.0158 5.20475 11.4838 3.95311 10.4199 2.91007C9.37689 1.84617 8.12525 1.31423 6.665 1.31423C5.20475 1.31423 3.94268 1.84617 2.87878 2.91007C1.83574 3.95311 1.31423 5.20475 1.31423 6.665C1.31423 8.12525 1.83574 9.38732 2.87878 10.4512ZM1.94005 1.97134C3.25427 0.657113 4.82926 0 6.665 0C8.50074 0 10.0653 0.657113 11.3587 1.97134C12.6729 3.2647 13.33 4.82926 13.33 6.665C13.33 8.50074 12.6729 10.0757 11.3587 11.39C10.0653 12.6833 8.50074 13.33 6.665 13.33C4.82926 13.33 3.25427 12.6833 1.94005 11.39C0.646682 10.0757 0 8.50074 0 6.665C0 4.82926 0.646682 3.2647 1.94005 1.97134ZM6.00789 10.0131V6.00789H7.32211V10.0131H6.00789Z",
  fill: "#07003D",
  fillOpacity: 0.5
});

var SvgSmallinfo = function SvgSmallinfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallinfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smallinfo.98192cb5.svg";
export { ForwardRef as ReactComponent };